const PILLARS = [
  {
    ref: "§ 1.1",
    title: "District & State Podiums",
    text: "Tournament-tested preparation that delivers verified medals and championship trophies.",
    testId: "pillar-medals",
  },
  {
    ref: "§ 1.2",
    title: "Micro Batches Only",
    text: "Every game is reviewed move-by-move. No student is lost in a crowded lecture.",
    testId: "pillar-batches",
  },
  {
    ref: "§ 1.3",
    title: "FIDE Rated Faculty",
    text: "Active competitors with official international ratings guiding your preparation.",
    testId: "pillar-fide",
  },
  {
    ref: "§ 1.4",
    title: "Zero Intimidation",
    text: "Beginners of any age find an encouraging, patient, and analytical home.",
    testId: "pillar-beginners",
  },
];

export const Pillars = () => {
  return (
    <section id="thesis" className="py-20 border-b border-stone-300 bg-white" data-testid="pillars-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="font-mono text-xs uppercase tracking-widest text-emerald-800 mb-2">Chapter 01</div>
            <h2 className="font-display text-3xl uppercase tracking-tight text-emerald-950">The Four Pillars</h2>
            <p className="text-sm text-stone-600 mt-2">
              Why our students consistently outplay peers with years more experience.
            </p>
          </div>

          <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-8">
            {PILLARS.map((pillar) => (
              <div key={pillar.ref} className="border-l-2 border-emerald-950 pl-5" data-testid={pillar.testId}>
                <div className="font-mono text-xs text-stone-400">{pillar.ref}</div>
                <h3 className="font-bold text-stone-900 text-lg mt-1">{pillar.title}</h3>
                <p className="text-sm text-stone-600 mt-2">{pillar.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
